import React from 'react';
import { LivePage, DataTable, Age, Code, clustersAPI } from './LivePage';

export default function StorageClasses() {
  return (
    <LivePage title="Storage Classes" fetchFn={id => clustersAPI.getWorkloadPaged('storageclasses', id, { pageSize: 500 })}>
      {(data) => {
        // Agent clusters return a raw K8s List (mixed PVC/PV/StorageClass items); normalize StorageClass items.
        const _raw = data.storage_classes || (data.items || []);
        const items = _raw
          .filter(it => (it.kind || 'StorageClass') === 'StorageClass')
          .map(it => it.metadata ? {
            name: it.metadata.name,
            provisioner: it.provisioner,
            reclaim_policy: it.reclaimPolicy || '',
            binding_mode: it.volumeBindingMode || '',
            default: (it.metadata.annotations || {})['storageclass.kubernetes.io/is-default-class'] === 'true',
            created_at: it.metadata.creationTimestamp,
          } : it);
        return (
          <DataTable cols={['Name', 'Provisioner', 'Reclaim Policy', 'Binding Mode', 'Default', 'Age']}
            rows={items.map(s => (
              <tr key={s.name}>
                <td><Code>{s.name}</Code>{s.default && <span className="badge success" style={{ marginLeft: 8 }}>default</span>}</td>
                <td style={{ fontSize: 12 }}>{s.provisioner}</td>
                <td style={{ fontSize: 12 }}>{s.reclaim_policy}</td>
                <td style={{ fontSize: 12 }}>{s.binding_mode}</td>
                <td>{s.default ? 'Yes' : '—'}</td>
                <td><Age ts={s.created_at} /></td>
              </tr>
            ))} />
        );
      }}
    </LivePage>
  );
}
